import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import * as React from "react";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import dayjs from "dayjs";
import {useProductCodeActions} from "../../../service/useProductCodeActions";
import {useStatusValuesLeisureAgreement} from "../../../component/useStatusValuesLeisureAgreement";
import {useStatusValuesProduct} from "../../../component/useStatusValuesProduct";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";


const LeisureAgreementDetailModal = (props: any) => {
    const {t} = useTranslation(['salesmarketing']);

    const {getStatusLabelAgreement} = useStatusValuesLeisureAgreement();
    const {getStatusColorProduct, getStatusLabelProduct} = useStatusValuesProduct();

    const theme = useTheme();
    const {leisureAgreement} = props;
    const {
        listSegment
    } = useProductCodeActions();
    const [segments, setSegments] = useState<any[]>([]);

    useEffect(() => {
        if (leisureAgreement) {
            listSegment().then(res => {
                setSegments(res);
            })
        }
    }, [leisureAgreement])

    return (
        leisureAgreement &&
        <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={props.open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('salesmarketing:leisureAgreement.detailTitle')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        props.handleClose();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    <UserLegalEntitiesOrDealersInputGroup tenantId={leisureAgreement.tenantId}
                                                          dealerId={leisureAgreement.dealerId}/>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="customerName"
                            label={t('salesmarketing:leisureAgreement.leisureCode')}
                            fullWidth
                            variant="standard"
                            value={leisureAgreement.leisureCode}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid xs={9}/>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('salesmarketing:leisureAgreement.status')}
                            fullWidth
                            variant="standard"
                            value={getStatusLabelAgreement(leisureAgreement.status)}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="segment"
                            label={t('salesmarketing:leisureAgreement.segment')}
                            fullWidth
                            variant="standard"
                            value={segments.length > 0 ? segments.find(s => s.segmentCode === leisureAgreement.segmentCode)?.segmentName : ""}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="customerName"
                            label={t('salesmarketing:leisureAgreement.customerName')}
                            fullWidth
                            variant="standard"
                            value={leisureAgreement.customerName}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="customerId"
                            label={t('salesmarketing:leisureAgreement.customerId')}
                            fullWidth
                            variant="standard"
                            value={leisureAgreement.customerId}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="name"
                            label={t('salesmarketing:leisureAgreement.name')}
                            fullWidth
                            variant="standard"
                            value={leisureAgreement.name}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="description"
                            label={t('salesmarketing:leisureAgreement.description')}
                            fullWidth
                            variant="standard"
                            value={leisureAgreement.description}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="leisureCode"
                            label={t('salesmarketing:leisureAgreement.leisureCode')}
                            fullWidth
                            variant="standard"
                            value={leisureAgreement.leisureCode}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="startDate"
                            label={t('salesmarketing:leisureAgreement.startDate')}
                            fullWidth
                            variant="standard"
                            value={leisureAgreement.startDate ? dayjs(leisureAgreement.startDate).format("L") : null}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="endDate"
                            label={t('salesmarketing:leisureAgreement.endDate')}
                            fullWidth
                            variant="standard"
                            value={leisureAgreement.endDate ? dayjs(leisureAgreement.endDate).format("L") : null}
                            inputProps={
                                {readOnly: true}
                            }
                        />
                    </Grid>
                </Grid>
                {leisureAgreement.productList.length > 0 &&
                    <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                        <Grid item>
                            <Typography>{t('salesmarketing:leisureAgreement.products.title')}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TableContainer>
                                <Table aria-label="productList-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t('salesmarketing:leisureAgreement.products.name')}</TableCell>
                                            <TableCell>{t('salesmarketing:leisureAgreement.products.code')}</TableCell>
                                            <TableCell>{t('salesmarketing:leisureAgreement.products.startDate')}</TableCell>
                                            <TableCell>{t('salesmarketing:leisureAgreement.products.endDate')}</TableCell>
                                            <TableCell>{t('salesmarketing:leisureAgreement.products.category')}</TableCell>
                                            <TableCell>{t('salesmarketing:leisureAgreement.products.status')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {leisureAgreement.productList.map((row: any, index: number) => (
                                            <TableRow
                                                key={"prd" + index}
                                            >
                                                <TableCell>{row.productName ? row.productName : ""}</TableCell>
                                                <TableCell>{row.productCode ? row.productCode : ""}</TableCell>
                                                <TableCell>{row.startDate ? dayjs(row.startDate).format("L") : ""}</TableCell>
                                                <TableCell>{row.endDate ? dayjs(row.endDate).format("L") : ""}</TableCell>
                                                <TableCell>{row.category ? row.category : ""}</TableCell>
                                                <TableCell>{row.status ?
                                                    <Chip label={getStatusLabelProduct(row.status)}
                                                          sx={{backgroundColor: getStatusColorProduct(row.status)}}/>
                                                    : ""}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                }
            </DialogContent>
            <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                <Button color={"accent"}
                        onClick={() => props.handleClose()}>{t('salesmarketing:leisureAgreement.buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default LeisureAgreementDetailModal;